import { IWidgetSettings } from './Widget/settings';

export interface IProviderLinks {
  oauthSignup: {
    method: string;
    url: string;
  };
  oauthConnect: {
    method: string;
    url: string;
  };
  oauthRevoke: {
    method: string;
    url: string;
  };
  oauthApiToken: {
    method: 'GET' | 'POST';
    url: string;
  };
}

export enum EConnectionTypeProvider {
  OAUTH = 'oauth',
  API_TOKEN = 'apikey'
}

export interface IProvider {
  name: string;
  availableFor: string[];
  displayName: string;
  status: string;
  authType: EConnectionTypeProvider;
  features: string[];
  required: boolean;
  description: string;
  type: string;
  links: IProviderLinks;
  connected: boolean;
  displayAsSignupOption: boolean;
  oauthId: string;
  account: string;
  settings: IWidgetSettings;
  shouldUpdate?: boolean;
}

export enum EConnectionTypeOauth {
  OAUTH = 'oauth',
  API_TOKEN = 'api-token'
}
export interface IConnectOauth {
  id: string;
  provider: string;
  status: string;
  businessId: string;
  connectionType: EConnectionTypeOauth;
}
